export enum TransactionType {
    eft_cash_in = 'eft_cash_in',
    transfer_to_bank = 'transfer_to_bank',
    atm_cash_in = 'atm_cash_in',
    marketplace_buy = 'marketplace_buy',
}
